const revokeCredentialTimeout = 60 * 1000;

export default revokeCredentialTimeout;
